import { ITiledSpringboardCard } from '@models/ITiledSpringboardCard';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import TiledSpringboardCard from '@molecules/TiledSpringboardCard/TiledSpringboardCard';

interface Props {
  readonly cards: [
    ITiledSpringboardCard,
    ITiledSpringboardCard,
    ITiledSpringboardCard,
    ITiledSpringboardCard,
    ITiledSpringboardCard,
  ];
}

const TiledSpringboard = ({ cards }: Props) => {
  const gridLayoutClassNames = [
    'xl:col-span-6 xl:row-span-2',
    'xl:col-span-6',
    'xl:col-span-6 xl:col-start-7',
    'xl:col-span-7 xl:col-start-6',
    'xl:col-span-5 xl:row-start-3',
  ];

  return (
    <section className="component-padding bg-black-100">
      <SoftLoadWrapper>
        <div className="container flex flex-col gap-y-7.5 xl:grid xl:grid-cols-12 xl:grid-rows-[repeat(3,_468px)] xl:gap-4">
          {cards.map((card, index) => (
            <TiledSpringboardCard
              {...card}
              key={card.title}
              className={gridLayoutClassNames[index]}
            />
          ))}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default TiledSpringboard;
